module.exports = function() {
  return new Worker(__webpack_public_path__ + "2a02049f3a9d33101f74.worker.js");
};